var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZeroHunger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Pasta-Bowl-Warm--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Pasta Bowl Warm Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.75a1 1 0 0 1 -0.68 -0.27 0.9 0.9 0 0 1 0 -1.3 1.49 1.49 0 0 0 0.47 -1.08 1.47 1.47 0 0 0 -0.47 -1.1 3.32 3.32 0 0 1 -1 -2.38 3.32 3.32 0 0 1 1 -2.38 1 1 0 0 1 1.36 0 0.9 0.9 0 0 1 0 1.3 1.49 1.49 0 0 0 -0.47 1.08 1.45 1.45 0 0 0 0.47 1.07 3.29 3.29 0 0 1 0 4.76 1 1 0 0 1 -0.68 0.3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5c-2.81 0 -12 0.23 -12 3.25C0 19.41 5.37 24 12 24s12 -4.59 12 -10.25c0 -3.02 -9.19 -3.25 -12 -3.25Zm0 2a32.63 32.63 0 0 1 9 1 0.25 0.25 0 0 1 0 0.5 32.63 32.63 0 0 1 -9 1 32.63 32.63 0 0 1 -9 -1 0.25 0.25 0 0 1 0 -0.48 32.63 32.63 0 0 1 9 -1.02Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.26 6.65a0.35 0.35 0 0 1 -0.06 0.4 1 1 0 0 0 0.7 1.7 1 1 0 0 0 0.71 -0.29 2.36 2.36 0 0 0 0.15 -3.22 4.32 4.32 0 0 1 -0.21 -0.38 0.35 0.35 0 0 1 0.06 -0.4 1 1 0 0 0 0 -1.41 1 1 0 0 0 -1.41 0 2.36 2.36 0 0 0 -0.15 3.22 4.32 4.32 0 0 1 0.21 0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.45 6.65a0.35 0.35 0 0 1 -0.06 0.4 1 1 0 0 0 0.7 1.7 1 1 0 0 0 0.71 -0.29 2.36 2.36 0 0 0 0.2 -3.22 4.32 4.32 0 0 1 -0.21 -0.38 0.35 0.35 0 0 1 0.06 -0.4 1 1 0 0 0 0 -1.41 1 1 0 0 0 -1.41 0 2.35 2.35 0 0 0 -0.15 3.22 4.32 4.32 0 0 1 0.16 0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZeroHunger);
export default ForwardRef;